/**
 *
 * LoadDivisions
 *
 */

import React from "react"
import PropTypes from "prop-types"
import { List, Button, Select } from "antd"
import "./index.less"
import parentImg from "../../images/parentImg.svg"
import ModalCustom from "../ModalCustom"

import alertSvg from "../../images/alert.svg"
import { LeftOutlined } from "@ant-design/icons"
import { woopraTrack } from "../../utils/woopra/woopraTracker"

const { Option } = Select
/* eslint-disable react/prefer-stateless-function */

const initialState = {
  parent: true,
  modalRetry: false,
  modalLeave: false,
  disabled: true,
  file: null,
  count_again: 1,
}
class LoadDivisions extends React.Component {
  constructor() {
    super()
    this.state = initialState
  }

  toggleModal = (modal, state) => {
    this.setState({ [modal]: state })
  }

  saveOK = (summary) => {
    woopraTrack("Finalizar Importar Divisiones")
    const { count_again } = this.state
    const params = {
      attempts: count_again,
      summary,
    }
    this.props.handleOk(params)
  }

  handleRetry = () => {
    this.setState({ modalRetry: false })
    this.props.change(false)
  }

  onModalRetry = () => {
    this.toggleModal("modalRetry", false)
    this.fileInput.click()
  }

  fileSelectedHandler = (event) => {
    let { count_again } = this.state
    event.preventDefault()
    const fd = new FormData()
    fd.append("uploaded_file", event.target.files[0])
    this.props.uploadTemplate(fd)
    this.fileInput.value = ""
    count_again++
    this.setState({ count_again })
  }

  render() {
    const { summary } = this.props
    const hasFreshchat =
      typeof window.Intercom !== "undefined" &&
      window.self === window.top;
    return (
      <div className="loadDivisionsContainer">
        <div>
          <div className="divisionsReport">
            <div
              className="backBtn"
              onClick={() => {
                woopraTrack("Volver a divisiones")
                this.toggleModal("modalLeave", true)
              }}>
              {" "}
              <LeftOutlined /> <span>Divisiones </span>
            </div>
            <h3 className="loadDivisionTitle" style={{ fontWeight: 600 }}>
              Importación de divisiones
            </h3>
            <span style={{ marginTop: "6px" }}>
              Revisa si se ha producido algún error en la importación de la
              información. De ser el caso, realiza las correcciones necesarias y
              vuelve a importar el archivo.{" "}
            </span>
            <h3 className="loadDivisionSubtitle" style={{ fontWeight: 600 }}>
              Resumen de importación
            </h3>
            <div className="resumeContainer">
              <span className="resumeSuccess">
                <strong>{summary.count_import}</strong>{" "}
                {summary.count_import == 1 ? "división" : "divisiones"}{" "}
                {summary.count_import == 1 ? "importada" : "importadas"}
              </span>
              {this.props.hasDivisions && (
                <span style={{ marginLeft: "1rem" }} className="resumeSuccess">
                  <strong>{summary.count_update}</strong>{" "}
                  {summary.count_update == 1 ? "división" : "divisiones"}{" "}
                  {summary.count_update == 1 ? "actualizada" : "actualizadas"}
                </span>
              )}
              <span className="resumeFailed">
                <strong>{summary.count_errors}</strong>{" "}
                {summary.count_errors == 1 ? "división" : "divisiones"} sin
                importar
              </span>
            </div>
            <p style={{ marginBottom: 0, color: "#4f4f4f" }}>
              A continuación se presentan los{" "}
              <span style={{ fontWeight: 600 }}>motivos de error</span> en la
              importación:
            </p>
          </div>
          <div className="errorTableContainer">
            <div className="tableStyles">
              <div className="listHeader">
                <span>División</span>
                <span>División superior</span>
                <span>Error</span>
                <span>Fila</span>
              </div>
              <List
                locale={{ emptyText: "No hay errores para mostrar" }}
                bordered
                dataSource={summary.list_errors}
                className="ListTest"
                style={{ backgroundColor: "#FFF" }}
                renderItem={(item) => (
                  <List.Item>
                    <div className="listItem">
                      <span>{item.division}</span>
                      <span>{item.division_parents}</span>
                      <span>{item.message}</span>
                      <span>{item.row}</span>
                    </div>
                  </List.Item>
                )}
              />
            </div>
            <div className= {`ldButtons ${hasFreshchat ? "buttonsFooterMargin" : ""}`} style={{ ...(typeof window.Intercom !== "undefined" &&
            window.self === window.top && {
            bottom: "16px!important"}) }}>
              <Button
                style={{ boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.15)" }}
                type="ghost"
                className="buttonRetry"
                onClick={() => {
                  woopraTrack("Reintentar Importar Divisiones")
                  this.toggleModal("modalRetry", true)
                }}>
                Reintentar
              </Button>
              <Button type="primary" onClick={() => this.saveOK(summary)}>
                Finalizar
              </Button>
            </div>
          </div>
        </div>
        <input
          style={{ display: "none" }}
          type="file"
          onChange={this.fileSelectedHandler}
          ref={(fileInput) => (this.fileInput = fileInput)}
        />

        <ModalCustom
          showFooter
          action="Reintentar Importar divisiones"
          onOk={this.onModalRetry}
          onCancel={() => this.toggleModal("modalRetry", false)}
          modalOpen={this.state.modalRetry}>
          <img src={alertSvg} className="alertIcon" />
          <span style={{ fontSize: 14, fontWeight: 600 }}>
            ¿Estás seguro de que deseas realizar una nueva importación?
          </span>
          <p style={{ fontSize: 13 }}>
            La información no será registrada y deberás iniciar un nuevo proceso
            de importación.
          </p>
        </ModalCustom>
        <ModalCustom
          showFooter
          action="Volver a divisiones"
          onOk={this.props.leave}
          onCancel={() => this.toggleModal("modalLeave", false)}
          modalOpen={this.state.modalLeave}>
          <img src={alertSvg} className="alertIcon" />
          <span style={{ fontSize: 14, fontWeight: 600 }}>
            ¿Estás seguro de que deseas salir de la importación?
          </span>
          <p style={{ fontSize: 13 }}>
            La información no será registrada y deberás iniciar un nuevo proceso
            de importación.
          </p>
        </ModalCustom>
      </div>
    )
  }
}

LoadDivisions.propTypes = { uploadTemplate: PropTypes.func.isRequired }

export default LoadDivisions
